import { COMPANY } from '../../config/companyConfig';
import { isDeeplinkFlightPath, resolveFlightStartDate } from './flightDeeplinkDate';

export const APP_SHARE_PREFIXES = ['/deeplinks', '/go'];

export function detectAppStoreClient(userAgent = '') {
  if (/Android/i.test(userAgent)) return 'android';
  if (/iPhone|iPad|iPod/i.test(userAgent)) return 'ios';
  return 'desktop';
}

export function toWebsitePathname(pathname) {
  let path = pathname || '/';
  for (const prefix of APP_SHARE_PREFIXES) {
    if (path === prefix) {
      path = '/';
      break;
    }
    if (path.startsWith(`${prefix}/`)) {
      path = path.slice(prefix.length) || '/';
      break;
    }
  }
  if (!path.startsWith('/') || path.startsWith('//') || path.includes('://') || path.includes('\\')) {
    path = '/';
  }
  return path;
}

export function toWebsitePath(pathname, search = '') {
  const path = toWebsitePathname(pathname);
  const raw = !search ? '' : search.startsWith('?') ? search : `?${search}`;
  if (!isDeeplinkFlightPath(pathname)) {
    return `${path}${raw}`;
  }

  const params = new URLSearchParams(raw.startsWith('?') ? raw.slice(1) : raw);
  const startDate = resolveFlightStartDate(pathname, params.get('startDate'));
  if (startDate) params.set('startDate', startDate);
  const qs = params.toString();
  return qs ? `${path}?${qs}` : path;
}

export function getStoreUrl(client) {
  if (client === 'android') return COMPANY.apps.android;
  if (client === 'ios') return COMPANY.apps.ios;
  return null;
}

export function buildAppShareUrl(pathAndQuery = '/') {
  const base = COMPANY.website.replace(/\/+$/, '');
  const raw = String(pathAndQuery || '/');
  const queryIndex = raw.indexOf('?');
  const pathPart = queryIndex >= 0 ? raw.slice(0, queryIndex) : raw;
  const queryPart = queryIndex >= 0 ? raw.slice(queryIndex) : '';
  let path = pathPart.startsWith('/') ? pathPart : `/${pathPart}`;

  if (path === '/deeplinks' || path.startsWith('/deeplinks/')) {
    return `${base}${path}${queryPart}`;
  }

  if (path === '/go' || path.startsWith('/go/')) {
    path = toWebsitePathname(path);
  }

  if (path === '/') return `${base}/deeplinks${queryPart}`;
  return `${base}/deeplinks${path}${queryPart}`;
}

export function isAppSharePath(pathname) {
  const path = pathname || '/';
  return (
    path === '/deeplinks' ||
    path.startsWith('/deeplinks/') ||
    path === '/go' ||
    path.startsWith('/go/')
  );
}
